export class BrandNotFoundError extends Error {
  constructor(public brandId: string) {
    super(`Brand with id ${brandId} not found.`)
  }
}
